<div class="popup-screen">
  <div class="popup-container">
    <div class="popup-header">
      Base Station Calibration
      <button type="button" class="close" (click)="close()" [hidden]="calibrationInProgress">&times;</button>
    </div>
    <div class="popup-body">
      <!-- Loading state -->
      <div *ngIf="loading" class="center-loader">
        <img src="./assets/img/loading_2.svg" alt="Loading..." class="loader-img" />
        <span class="loading-text">Loading calibration status...</span>
      </div>

      <div *ngIf="!loading">
        <!-- Progress bar -->
        <div class="progress-bar-container">
          <div class="step-progress"
               *ngFor="let step of steps"
               [ngClass]="{
                 'completed': step.status === 'COMPLETED',
                 'failed': step.status === 'FAILED',
                 'in-progress': step.status === 'STARTED' || step.status === 'IN_PROGRESS'
               }">
          </div>
        </div>

        <!-- Steps list with initial status -->
        <div class="steps-container">
          <div class="step-container" *ngFor="let step of steps; let i = index">
            <div class="step-header">
              <span class="step-name" [ngClass]="step.status.toLowerCase()">
                {{step.name}}
              </span>
              <!-- Update status display -->
              <span class="step-status">
                <ng-container [ngSwitch]="step.status">
                  <span *ngSwitchCase="'COMPLETED'" class="status-completed">
                    COMPLETED
                    <i class="fas fa-check-circle color-inherit"></i>
                  </span>
                  <span *ngSwitchCase="'FAILED'" class="status-failed">
                    FAILED
                    <i class="fas fa-times-circle color-inherit"></i>
                  </span>
                  <span *ngSwitchCase="'IN_PROGRESS'" class="status-progress">
                    IN_PROGRESS
                    <img src="./assets/img/loading_2.svg" class="loader-img" alt="" />
                  </span>
                </ng-container>
              </span>
            </div>
            <div *ngIf="step.displayData" class="step-data">
              <div *ngFor="let key of getKeys(step.displayData)" class="data-item">
                <span class="data-label">{{key}}:</span>
                <span class="data-value">{{step.displayData[key]}}</span>
              </div>
            </div>
            <div *ngIf="step?.['nearest_sations']?.['stations'] && currentStep === 7 && waitingForStationSelection" class="station-selection">
              <label for="stationSelect">Select a station:</label>
              <div class="flex-start">
                <button class="btn btn-primary-soft" (click)="openMapPopup(step['nearest_sations']['stations'])" *ngIf="step['nearest_sations']['stations'].length > 0">
                  <i class="fa-solid fa-location-dot color-inherit"></i>
                </button>
                <select id="stationSelect" class="form-select" [(ngModel)]="selectedStation">
                  <option *ngFor="let station of step['nearest_sations']['stations']" [ngValue]="station">
                    {{station.name}} ({{station.distance.toFixed(2)}} km) (status: {{station.status}})
                  </option>
                </select>
                <button class="btn btn-primary-soft" [disabled]="!selectedStation" (click)="submitStationSelection()">Submit</button>
              </div>
            </div>
            <div *ngIf="step.status === 'IN_PROGRESS'" class="step-progress-indicator">
              Checking status...
              <img src="./assets/img/loading_2.svg" class="loader-img" alt="" />
            </div>
            <div *ngIf="step.comment" class="step-comment">
              {{step.comment}}
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="popup-footer">
      <ng-container *ngIf="hasFailedSteps; else normalButtons">
        <button class="btn btn-primary-soft"
                (click)="rerunFromFailed()"
                [disabled]="calibrationInProgress">
          <img src="./assets/img/loading_2.svg" *ngIf="calibrationInProgress" class="loader-img" alt="" />
          <span>Continue from failed step</span>
        </button>
        <button class="btn btn-primary-soft"
                (click)="openRouterIPPopup()"
                [disabled]="calibrationInProgress">
          <img src="./assets/img/loading_2.svg" *ngIf="calibrationInProgress" class="loader-img" alt="" />
          <span>{{calibrationInProgress ? 'Calibrating...' : 'Re-calibrate'}}</span>
        </button>
      </ng-container>
      <ng-template #normalButtons>
        <button class="btn btn-primary-soft"
                (click)="openRouterIPPopup()"
                [disabled]="calibrationInProgress">
          <img src="./assets/img/loading_2.svg" *ngIf="calibrationInProgress" class="loader-img" alt="" />
          <span>{{calibrationInProgress ? 'Calibrating...' : hasCalibrationData ? 'Re-calibrate' : 'Calibrate'}}</span>
        </button>
      </ng-template>
      <button class="btn btn-light" (click)="close()" [hidden]="calibrationInProgress">Close</button>
    </div>
  </div>
</div>

<div class="popup-screen z-index-more" *ngIf="showRouterIPPopup">
  <div class="popup-container">
    <div class="popup-header">
      Select Router
      <button type="button" class="close" (click)="showRouterIPPopup = false">&times;</button>
    </div>
    <div class="popup-body p-3">
      <label for="KitSelectionSelect" class="fw-bold">Select Transceiver Kit</label>
      <select id="KitSelectionSelect" (change)="getRouterIPs()" class="form-select" [(ngModel)]="selectedKit">
        <option *ngFor="let kit of kits" [value]="kit.value">{{ kit.value }}</option>
      </select>
    </div>
    <div class="popup-body p-3">
      <label for="routerIPSelect" class="fw-bold">Select Base Station</label>
      <select id="routerIPSelect" class="form-select" [(ngModel)]="selectedRouterIP">
        <option *ngFor="let ip of routerIPs" [value]="ip.ip">{{ ip.name }}</option>
      </select>
    </div>
    <div class="popup-footer">
      <button class="btn btn-primary-soft" (click)="submitRouterIPSelection()">Submit</button>
      <button class="btn btn-light" (click)="showRouterIPPopup = false">Close</button>
    </div>
  </div>
</div>

<app-map-popup *ngIf="mapData" [comments]="mapData" [baseStation]="this.steps[5]['displayData']" (close)="handleCloseMap()"></app-map-popup>
